import { APICallV3Get } from 'reactApp/api/APICall';

export class ViewArchiveItemDownloadAPICall extends APICallV3Get {
    _method = 'unzip/get/';
}
